var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-btn',{staticClass:"mb-5",attrs:{"color":"default","to":{
    name: 'membership-College',
    query: {
      collegeModuleId: _vm.collegeModuleId,
      collegeDocumentId: _vm.id,
    },
  }}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdiArrowLeft))]),_vm._v(" "+_vm._s(_vm.$t('common.back'))+" ")],1),_c('v-card',{attrs:{"loading":_vm.isLoading}},[(_vm.collegeDocument)?_c('v-card-title',{attrs:{"primary-title":""}},[_vm._v(" "+_vm._s(_vm.collegeDocument.title)+" ")]):_vm._e(),(_vm.collegeDocument)?_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.collegeDocument.content)}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }